import { Radio, RadioValue, Space, Switch, SwitchValue } from 'tdesign-react';

import { MediaConfigType, RichMediaShowType } from '@/const/richMedia';
import { RichMediaValue } from '@/interface/media';

import { getMediaConfig } from './config';
import styles from './index.module.less';

interface RichMediaProps<T> {
  richMedia?: { type: MediaConfigType };
  onChange: (key: string, value: RadioValue | SwitchValue) => void;
  value: T | RichMediaValue;
  disabled?: boolean;
}

export interface RichMedia {
  render: string;
  label: string;
  key: string;
  options?: {
    label: string;
    value: RichMediaShowType;
  }[];
}

export const RichMedia: React.FC<RichMediaProps<any>> = (props) => {
  const { richMedia, onChange, value, disabled = false } = props;
  if (!richMedia) {
    return null;
  }
  const { type } = richMedia;
  const config = getMediaConfig(type);

  const handleOnChange = (key: string, value: RadioValue | SwitchValue) => {
    onChange(key, value);
  };

  return (
    <Space direction="vertical" size={10}>
      {config?.map((e, i) => {
        const prop = e.props as keyof Omit<RichMediaValue, 'url'>;
        if (e.render === 'radio') return (
            <div key={i}>
              <Radio.Group
                {...e}
                key={i}
              className={styles.radio}
              style={{ gap: 12 }}
                value={value[prop]}
                disabled={disabled}
                onChange={(value: RadioValue) => handleOnChange(prop, value)}
              />
            </div>
        );
        if (e.render === 'switch') return (
            <Switch
              style={{ marginRight: '10px' }}
              {...e}
              key={i}
              disabled={disabled}
              value={value[prop]}
              onChange={(value: SwitchValue) => handleOnChange(prop, value)}
            />
        );
        return null;
      })}
    </Space>
  );
};
